module.exports = __webpack_public_path__ + "img/es-ga.es-gafe67f0e.svg";